module.exports = __webpack_public_path__ + "img/SET_NOYA_05H04.acd733c2.jpg";